// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + {"65":"comparison-bulk","348":"comparison"}[chunkId] + "." + {"65":"27e7999b","348":"d7dc1ecc"}[chunkId] + ".chunk.js";
};